import useMenuItemEr from './useMenuItemEr.jsx'
import useMenuItemSampleData from './useMenuItemSampleData.jsx'

export default () => {
    const menuItemEr = useMenuItemEr()
    const menuItemSampleData = useMenuItemSampleData()

    return (map, nodes) => [
        menuItemEr(map, nodes),
        menuItemSampleData(map, nodes)
    ]
}
